/**
 * EXPORT — the primary action on six of the manager's boards, and on most of
 * the accountant's. Shared here because both surfaces mean the same thing by
 * it, and two copies would drift on the one detail that matters: what the file
 * is allowed to claim.
 *
 * There is no report-export endpoint in the backend, and a button that opens a
 * "coming soon" toast is the dead control §8 spends a section on. So Export is
 * what it says: the rows on screen, as they are on screen, written to a CSV the
 * browser downloads. The figures come from the same arrays the table renders,
 * so the file and the screen cannot disagree.
 *
 * What is NOT claimed: the board's "Excel, CSV or a branded PDF, and every
 * export is a line in the audit log". CSV is real; the other two formats and
 * the audit line need a server that renders and records them — logged as a
 * BACKEND-GAP in reports/clinic-manager.md.
 */

function cell(v: unknown): string {
  let s = v === null || v === undefined ? '' : String(v);
  /* A typed name like `=HYPERLINK(…)` is a formula to Excel. Text that opens
     with a formula trigger is quoted with a leading apostrophe; numbers stay
     numbers, so a negative balance still sums. */
  if (typeof v === 'string' && /^[=+\-@\t\r]/.test(s)) s = `'${s}`;
  return /[",\n]/.test(s) ? `"${s.replace(/"/g, '""')}"` : s;
}

export function exportCsv(filename: string, headers: string[], rows: unknown[][]): void {
  const body = [headers, ...rows].map((r) => r.map(cell).join(',')).join('\r\n');
  /* The BOM is what makes Excel open an Arabic clinic's names as UTF-8 rather
     than as mojibake. */
  const blob = new Blob([`\uFEFF${body}`], { type: 'text/csv;charset=utf-8' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename.endsWith('.csv') ? filename : `${filename}.csv`;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
